module.exports = __webpack_public_path__ + "static/media/03-icon.7d93027e.svg";